import React from "react";
import Logo from "../../../assets/CC ATS Logo.png";

export const Loader = () => {
    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/90 backdrop-blur-sm">
            <div className="flex flex-col items-center">

                {/* Animated Rings */}
                <div className="relative flex items-center justify-center">

                    <div className="absolute h-32 w-32 rounded-full border-4 border-primary-200"></div>

                    <div className="absolute h-32 w-32 rounded-full border-4 border-transparent border-t-primary-600 animate-spin"></div>

                    <div className="absolute h-24 w-24 rounded-full border-4 border-transparent border-b-secondary-500 animate-spin [animation-direction:reverse]"></div>

                    {/* Logo */}
                    <div className="h-20 w-20 rounded-full bg-white shadow-xl flex items-center justify-center">
                        <img
                            src={Logo}
                            alt="CC ATS"
                            className="h-14 w-14 object-contain animate-pulse"
                        />
                    </div>
                </div>

                {/* Loading Text */}
                <h2 className="mt-8 text-xl font-bold text-gray-800">
                    CareerConnect ATS
                </h2>

                <p className="mt-2 text-gray-500">
                    Loading reports...
                </p>

                {/* Animated Dots */}
                <div className="mt-5 flex gap-2">
                    <span className="h-3 w-3 rounded-full bg-primary-600 animate-bounce"></span>
                    <span
                        className="h-3 w-3 rounded-full bg-primary-600 animate-bounce"
                        style={{ animationDelay: "0.2s" }}
                    ></span>
                    <span
                        className="h-3 w-3 rounded-full bg-primary-600 animate-bounce"
                        style={{ animationDelay: "0.4s" }}
                    ></span>
                </div>
            </div>
        </div>
    );
};